/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-09-24 21:11:34
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-21 15:36:16
 */
export enum RouterNameEnum {
  LOGIN_ROUTER_NAME = 'login',
  ROOT_ROUTER_NAME = 'root',
  HOME_ROUTER_NAME = 'home',
  APP_CARD_LIST_ROUTER_NAME = 'app',
  APP_SETTING_ROUTER_NAME = 'appSetting',
  SETTING_ROUTER_BASIC__NAME = 'setting',
  SETTING_ROUTER_NAME = 'system',
  DATA_CENTER = 'node',

  WELCOME = 'welcome',
  WELCOME_INDEX = 'welcomeIndex',

  // 基础服务
  BASE_SERVER_ROUTER_NAME = 'baseServer',
  BASE_SERVER_USER_ROUTER_NAME = 'user',
  BASE_SERVER_ROLE_ROUTER_NAME = 'role',

  //  对外接入
  OPEN_LESS_ROUTER_NAME = 'openLess',
  OPEN_LESS_EXTENDED_APPLICATION_ROUTER_NAME = 'openLessExtendedApplication',
  OPEN_LESS_EXTERNAL_ACCESS_ROUTER_NAME = 'openLessExternalAccess',

  // license授权中心
  LICENSE_CENTER = 'licenseSenter',
  LICENSE_AUTH = 'licenseAuth',
  LICENSE_NAME = 'licenseName',
  SEC_KEY_MAN = 'secretKeyman',
  ADD_AUTH_NAME = 'addAuthname',
  ADD_AUTH_KEY = 'addAuthkey', // 添加应用授权
  LICENSE_DETAIL = 'licenseDetail', // license详情
  REMOTE_APP = 'remoteApp',
  REMOTE_APP_DETAILS = 'remoteAppDetail',
  // 运营中心
  OPERATE_CENTER = 'operateCenter',
  REMOTE_APPLICATION = 'remoteApplication', // 远程应用
  REMOTE_APPLICATION_DETAILS = 'remoteApplicationDetail', // 远程应用详情
  APPLICATION_AUTH = 'applicationAuth', // 应用授权
  APPLICATION_MANAGEMENT = 'applicationManagement',
  APPLICATION_KEY = 'applicationKey', // 应用密钥

  // 在线商店
  ONLINE_SHOP_ROUTER_NAME = 'onlineShop',
  // 应用商店
  APP_SHOP_ROUTER_NAME = 'appShop',
  // 应用商店应用详情
  APP_SHOP_DETAILS_ROUTER_NAME = 'appShopDetail',
  // 算法商店
  ALGORITHM_SHOP_ROUTER_NAME = 'algorithmShop',
  // 算法详情
  ALGORITHM_DETAILS_ROUTER_NAME = 'algorithmDetail',
  // 算法分组
  ALGORITHM_GROUP_ROUTER_NAME = 'algorithmGroup',
  // 产品安装记录
  PRODUCT_INSTALL_RECORD_ROUTER_NAME = 'productInstallRecord',

  // 系统服务
  SYSTEM_SERVICE_ROUTER_NAME = 'systemService',
  // 系统日志
  SYSTEM_LOG_ROUTER_NAME = 'systemLog',
  // 储存服务
  STORAGE_SERVICE_ROUTER_NAME = 'storageService',

  // 系统相关
  // 系统用户
  SYSTEM_USER_ROUTER_NAME = 'systemUser',

  FILE_PUBLISH = 'filePublish',
  FILE_PUBLISH_DOWNLOAD = 'filePublishDownload',

  // CRRS
  CRRS = 'crrs',
  // 鲲云文件发布中心
  FILE_PUBLISH_CENTER = 'filePublishCenter',
  // 文件上传
  FILE_UPLOAD = 'fileUpload',
  // 文件下载
  FILE_DOWNLOAD = 'fileDownload',
  CRRS_CENTER = 'crrsCenter',

  FEEDBACK = 'feedback',
  // 蓝图助手问题反馈
  BLUEPRINT_ASSISTANT_FEEDBACK = 'blueprintAssistantFeedback',
  DOWNLOAD_PLUGIN = 'downloadPlugin',

  // 用于内网上传
  PUBLISH = 'publish',
  FILE_PUBLISH_UPLOAD = 'filePublishUpload'
}
